export const URL_SERVER = "192.168.244.46:8000"; //Tai
// export const URL_SERVER = "192.168.5.95:8000"; //Tai
// export const URL_SERVER = "192.168.43.169:8000"; //Huy
// export const URL_SERVER = "172.20.10.5:8000"; //Thanh
